import React from 'react'
import { connect } from 'react-redux'
import Resx from '@/components/Resx'
import Comments from '@/components/comments/Comments'
import TicketCommentItem from './ticketCommentItem'
import { actionCreators } from '@/store/TicketComments'
import LoadingIndicator from '@/components/LoadingIndicator'
import CheckBox from '@/components/CheckBox'

class MyTicketComments extends React.Component {
  constructor (props, context) {
    super(props, context)
    this.box = React.createRef()

    this.state = {
      includeRelatedTickets: false,
      boxHeight: null
    }
  }

  componentWillMount () {
    this.reloadComments(this.props.ticketId)
  }
  handleCommentCreated (newComment) {
    this.props.addComment(newComment)
  }
  reloadComments (ticketId) {
    this.props.getComments(ticketId, this.state.includeRelatedTickets)
  }
  renderComments () {
    const { ticketComments, author, ticketId } = this.props

    if (ticketComments.fetching === true || ticketComments.adding === true) { return <LoadingIndicator /> }
    if (this.state.includeRelatedTickets === false) {
      const ticketComment = ticketComments.ticketComments[0]
      if (!ticketComment) return null
      return <Comments key={`comments_${ticketId}`} author={author} comments={ticketComment.comments} isAddingComment={ticketComments.adding} onCommentCreated={newComment => this.handleCommentCreated({ entityId: ticketComment.id, ...newComment })} />
    } else {
      return ticketComments.ticketComments.map((ticketComment, index) => <TicketCommentItem key={`comment_item_${ticketId}_${index}`} author={author} ticketComment={ticketComment} isAddingComment={ticketComments.adding} onCommentCreated={newComment => this.handleCommentCreated({ entityId: ticketComment.id, ...newComment })} />)
    }
  }
  render () {
    const { ticketId, title } = this.props
    return (
      <React.Fragment>
        <div className='box__title box__title--subtitle'><Resx name={title || 'Tasks.Comments'} />
          <div className={'pull-right'}>
            <CheckBox
              checked={this.state.includeRelatedTickets}
              onChange={checked => this.setState({ includeRelatedTickets: checked }, () => this.reloadComments(ticketId))}
              title={'Common.IncludeRelatedTickets'} />
          </div>
        </div>
        {this.renderComments()}
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    ticketComments: state.ticketComments,
    author: state.identity.user.profile.name,
    ...ownProps
  }
}

const mapDispatchToProps = {
  getComments: actionCreators.getComments,
  addComment: actionCreators.addComment
}

export default connect(mapStateToProps, mapDispatchToProps)(MyTicketComments)



// WEBPACK FOOTER //
// ./src/internal-app/pages/tickets/comments/myTicketComments.js